import { render, staticRenderFns } from "./with-sidebar.vue?vue&type=template&id=5e51ec8e&scoped=true&"
import script from "./with-sidebar.vue?vue&type=script&lang=js&"
export * from "./with-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./with-sidebar.vue?vue&type=style&index=0&id=5e51ec8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e51ec8e",
  null
  
)

export default component.exports